module.exports = __webpack_public_path__ + "static/media/header2.e56ef98f.jpg";